import { z } from 'zod';
import { paginationInput, idInput, periodoInput } from './common';

export const formaPagamentoEnum = z.enum(['DINHEIRO', 'CARTAO_CREDITO', 'CARTAO_DEBITO', 'PIX']);

export const itemVendaInput = z.object({
  produtoId: z.string().uuid(),
  quantidade: z.number().int().positive('Quantidade deve ser positiva'),
  /**
   * Peças específicas que saem nesta venda.
   *
   * Quando presente, são exatamente essas que ficam marcadas como vendidas —
   * é o que o PDV envia depois de escanear as etiquetas. Quando ausente (venda
   * por toque, sem leitura), o servidor escolhe as de menor sequência.
   */
  unidadeIds: z.array(z.string().uuid()).optional(),
  /**
   * @deprecated Ignorado pelo servidor — o preço sai sempre do banco.
   * Mantido para não quebrar clientes que ainda o enviam.
   */
  precoUnitario: z.string().optional(),
});

export const createVendaInput = z.object({
  items: z.array(itemVendaInput).min(1, 'Venda deve ter pelo menos 1 item'),
  formaPagamento: formaPagamentoEnum,
});

export const listVendasByCaixaInput = idInput.merge(paginationInput);

export const cancelarVendaInput = z.object({
  vendaId: z.string().uuid(),
  motivo: z.string().min(3, 'Motivo é obrigatório'),
});

export const itemVendaOutput = z.object({
  id: z.string(),
  produtoId: z.string(),
  produtoNome: z.string(),
  quantidade: z.number(),
  precoUnitario: z.string(),
  subtotal: z.string(),
});

export const vendaOutput = z.object({
  id: z.string(),
  caixaId: z.string(),
  userId: z.string(),
  formaPagamento: formaPagamentoEnum,
  valorTotal: z.string(),
  cancelada: z.boolean(),
  createdAt: z.date(),
  itens: z.array(itemVendaOutput),
});

export type ItemVendaInput = z.infer<typeof itemVendaInput>;
export type CreateVendaInput = z.infer<typeof createVendaInput>;
export type ListVendasByCaixaInput = z.infer<typeof listVendasByCaixaInput>;
export type CancelarVendaInput = z.infer<typeof cancelarVendaInput>;
export type ItemVendaOutput = z.infer<typeof itemVendaOutput>;
export type VendaOutput = z.infer<typeof vendaOutput>;

export const relatorioVendasInput = periodoInput.extend({
  limiteRanking: z.number().int().positive().max(100).default(20),
});

export const listVendasPeriodoInput = periodoInput.merge(paginationInput).extend({
  /** Estorno some das somas, mas precisa ser visível para conferência. */
  incluirCanceladas: z.boolean().default(false),
});

export type RelatorioVendasInput = z.infer<typeof relatorioVendasInput>;
export type ListVendasPeriodoInput = z.infer<typeof listVendasPeriodoInput>;
